import { Injectable, SkipSelf } from '@angular/core';
import { ApiEndPointsDocument } from '../common/apiUrls/api-end-points-document';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { EnvService } from 'src/app/env.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {
  private baseUrl:any;
  private baseUrlTrans:any;
  private baseUrlRole:any;
  private baseUrlUser:any;
  constructor(@SkipSelf()private _http: HttpClient, 
  private apiAddress: ApiEndPointsDocument, public env: EnvService,
    private constant: Constants) {
      if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
     this.baseUrl = this.constant.ManageContactsportNumber;
else
     this.baseUrl = this.env.apiUrl+this.constant.ManageContactsportNumber;
     if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
     this.baseUrlTrans = this.constant.ManageTranscationportNumber;
else
     this.baseUrlTrans = this.env.apiUrl+this.constant.ManageTranscationportNumber;
     if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
     this.baseUrlRole = this.constant.RolePortNumber;
else
     this.baseUrlRole = this.env.apiUrl+this.constant.RolePortNumber;

     if(this.env.apiUrl==undefined  || this.env.apiUrl=='')
      this.baseUrlUser = this.constant.ManageUserPortNumber;
    else   
    this.baseUrlUser = this.env.apiUrl+this.constant.ManageUserPortNumber;
  }

  //  private baseUrl = this.env.apiUrl;
    // private baseUrl = this.env.apiUrl+this.constant.ManageContactsportNumber;
    // private baseUrlTrans = this.constant.ManageTranscationportNumber;
    // //private baseUrlTrans = this.env.apiUrl+this.constant.ManageTranscationportNumber;
    // // private baseUrlRole = this.env.apiUrl+this.constant.RolePortNumber; 
    // private baseUrlRole = this.constant.RolePortNumber; 

    getContacts(reqModel): Observable<any> {
      const apiURL = this.baseUrl + this.apiAddress.getContacts;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNormalAndSharedContacts(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans+ this.apiAddress.getNormalAndSharedContacts;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNormalAndSharedCompanyContacts(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans+ this.apiAddress.getNormalAndSharedCompanyContacts;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNormalAndSharedContactContacts(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans+ this.apiAddress.getNormalAndSharedContactContacts;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNormalAndSharedCompanys(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans+ this.apiAddress.getNormalAndSharedCompanys;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNormalAndSharedContactCompanys(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans+ this.apiAddress.getNormalAndSharedContactCompanys;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNormalAndSharedContactCores(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans+ this.apiAddress.getNormalAndSharedContactCores;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getNormalAndSharedCompanyCores(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans+ this.apiAddress.getNormalAndSharedCompanyCores;
      return this._http.post(apiURL, reqModel).pipe();
    }

    deleteSelectedContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.deleteSelectedContact;
      return this._http.post(apiURL, reqModel).pipe();
    }

    deleteSelectedContactContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.deleteSelectedContactContact;
      return this._http.post(apiURL, reqModel).pipe();
    }

    deleteSelectedCompanyContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.deleteSelectedCompanyContact;
      return this._http.post(apiURL, reqModel).pipe();
    }

    deleteSelectedCompany(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.deleteSelectedCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }

    deleteContactSelectedCompany(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.deleteContactSelectedCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }


    deleteSelectedRoleCompany(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.deleteSelectedRoleCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }

    deleteSelectedRoleContactCompany(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.deleteSelectedRoleContactCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }


    GetContactListCoreImplementation(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.GetContactListCoreImplementation;
      return this._http.post(apiURL, reqModel).pipe();
    }

    GetUserList(reqModel): Observable<any> {
      const apiURL = this.baseUrlUser + this.apiAddress.GetUserList;
      return this._http.post(apiURL, reqModel).pipe();
    }

    GetCompanyListCoreImplementation(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.GetCompanyListCoreImplementation;
      return this._http.post(apiURL, reqModel).pipe();
    }

    CreatePendingContactPCC(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.CreatePendingContactPCC;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getTransactinalRoles(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getTransactinalRoles;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getSharedAccessRoles(reqModel): Observable<any> {
      const apiURL = this.baseUrlRole + this.apiAddress.getSharedAccesslRoles;
      return this._http.post(apiURL, reqModel).pipe();
    }


    addUpdateCoreContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateCoreContact;
      return this._http.post(apiURL, reqModel).pipe();
    }
    
    addUpdateContactContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateContactContact;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addUpdateCompanyContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateCompanyContact;
      return this._http.post(apiURL, reqModel).pipe();
    }
    

    addUpdateContactCompany(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateContactCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addUpdateCoreCompany(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateCoreCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }

    

    addUpdateCoreContactRole(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateCoreContactRole;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addUpdateContactContactRole(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateContactContactRole;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addUpdateCompanyContactRole(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateCompanyContactRole;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addUpdateCoreCompanyRole(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateCoreCompanyRole;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addUpdateContactCompanyRole(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addUpdateContactCompanyRole;
      return this._http.post(apiURL, reqModel).pipe();
    }

    AddCoreDocReviewer(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.AddCoreDocReviewer;
      return this._http.post(apiURL, reqModel).pipe();
    }

    AddContactDocReviewer(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.AddContactDocReviewer;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getFormFolderList(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getFormFolderList;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getFormFolderWithFormTemplates(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getFormFolderWithFormTemplates;
      return this._http.post(apiURL, reqModel).pipe();
    }

    GetParentFormFolderHierarchy(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.GetParentFormFolderHierarchy;
      return this._http.post(apiURL, reqModel).pipe();
    }

    FileManagerItemsWithHierarchy(reqModel):Observable<any>{
      const apiURL = this.baseUrlTrans + this.apiAddress.FileManagerItemsWithHierarchy;
      return this._http.post(apiURL, reqModel).pipe();
     }
  
     getFoldersListForFML(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getFileManagerFolderList;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getFormFolderSharedWithMeList(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getFormFolderSharedWithMe;
      return this._http.post(apiURL, reqModel).pipe();
    }

    getFormFolderWithFormTemplatesSharedWithMe(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.getFormFolderWithFormTemplatesSharedWithMe;
      return this._http.post(apiURL, reqModel).pipe();
    }

    GetSharedWithMeFileManager (reqModel): Observable<any> {    
      const apiURL =  this.baseUrlTrans + this.apiAddress.GetSharedWithMeFileManager;
      return this._http.post(apiURL, reqModel).pipe();
    }
    
    GetSharedWithMeFileManagerWithHierarchy (reqModel): Observable<any> {    
      const apiURL =  this.baseUrlTrans + this.apiAddress.GetSharedWithMeFileManagerWithHierarchy;
      return this._http.post(apiURL, reqModel).pipe();
    }

    addPortalAccessToContact(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.addPortalAccessToContact;
      return this._http.post(apiURL, reqModel).pipe();
    }
  
   getCoreUserDetails(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getCoreUserDetails;
    return this._http.post(apiURL, reqModel).pipe();
  }

}
